import { render, staticRenderFns } from "./Sms-news.vue?vue&type=template&id=64de99b3"
import script from "./Sms-news.vue?vue&type=script&lang=js"
export * from "./Sms-news.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports